<script>

    export let value = null
    export let label = null
    export let required = true

    let isValid = true

    function verifyEmail() {
        isValid = /[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}/.test(value)
    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control has-icons-left">
        <span class="icon"><i class="fas fa-envelope"></i></span>
        <input on:keyup={ verifyEmail } bind:value={ value } class="input" type="email" placeholder="Correo" pattern={ '[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{1,5}' } class:is-invalid={ !isValid } { required } >
    </div>
</div>